import src from "IMAGE";
export default { src, width: 1024, height: 322, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAQAAAAEwYbDAAAAPklEQVR42gEzAMz/AAvwK/IT8hzyHPIY8hnyCfAAQ/+l/zD/Pf84/z3/Nf8V/wAX80X1HvU89Sv1K/Uq9RHzptUbP/6uZbIAAAAASUVORK5CYII="};
